import Navigation from "../../components/Navigation";
// import Footer from "../../components/Footer";
import { Link } from "react-router-dom"; // Import Link for internal routing
import { FileText, Gavel, Briefcase } from "lucide-react"; // Icons for services preview
import { Helmet } from "react-helmet-async";
import "./style.css"; // Ensure file name is Home.css
import Testimonials from "../../components/Testimonials";
import TrustedBy from "../../components/TrustedBy";
import Pricing from "../../components/Pricing"; // Import the Pricing component

const coreServices = [
    {
        title: "Taxation",
        desc: "Optimized tax strategies to maximize savings and ensure compliance for all entities.",
        icon: FileText,
        // slug: "/services/tax-advisory",
    },
    {
        title: "Legal Advisory",
        desc: "Expert legal guidance for contracts, compliance, corporate law, and dispute resolution.",
        icon: Gavel,
        // slug: "/services/legal-consulting",
    },
    {
        title: "Secretarial Services",
        desc: [
            "Estate Late Tax Registrations",
            "Final and Outstanding Tax Returns",
            "Liaison with SARS",
            "Tax Compliance for Deceased Estates"
        ],
        icon: Briefcase,
        // slug: "/services/business-solutions",
    },
];

const Home = () => {
    return (
        <div className="home-page-wrapper">
            <Navigation />
            <Helmet>
                <title>Jean Tax & Legal Practitioners | Home</title>
                <meta name="description" content="Jean Tax & Legal Practitioners: Expert tax, legal, and secretarial services for individuals and businesses in South Africa." />
                <meta name="keywords" content="tax services, legal advisory, SARS compliance, deceased estate, bookkeeping, South Africa" />
                <link rel="canonical" href="https://jeantaxandlegal.co.za/" />
                <meta property="og:title" content="Jean Tax & Legal Practitioners | Home" />
                <meta property="og:description" content="Premium tax & legal solutions for businesses and individuals in South Africa." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://jeantaxandlegal.co.za/" />
            </Helmet>
            <main className="home">
                
                {/* Hero Section */}
                <section className="hero">
                    <div className="container">
                        <div className="hero-content">
                            <h1>Expert Tax & Legal Solutions</h1>
                            <div className="hero-underline"></div>
                            {/* <p>Providing premium, tailored services and insights for businesses and individuals across South Africa.</p> */}

                            {/* Mission Statement */}
                            <h2>Mission Statement</h2>
								<p>Our mission is to support businesses and individuals by providing reliable taxation, accounting, and compliance services. We aim to help clients navigate complex financial regulations through professional advisory services, compliance strategies, and practical solutions that promote sustainable business practices.</p>
                                <p style={{ fontSize: "3.25rem", fontWeight: "600" }}>Need Tax or Legal Help?</p>
                            {/* Use Link component for smooth internal navigation */}
                            <Link to="/contact" className="btn-primary">
                                Book a Consultation
                            </Link>
                        </div>
                    </div>
                </section>

                {/* Services Preview Section */}
                <section className="services-preview">
                    <div className="container">
                        <h2>Our Core Services</h2>
                        <div className="hero-underline"></div>
                        <div className="services-cards-grid">
                            {coreServices.map((service, index) => (
                                <Link to={service.slug} className="service-card-link" key={index}>
                                    <div className="card service-preview-card">
                                        {/* Render the Lucide icon */}
                                        <div className="card-icon">
                                            {service.icon && <service.icon size={32} />}
                                        </div>
                                        <h3 className="card-title">{service.title}</h3>
                                        <p className="card-description">{service.desc}</p>
                                    </div>
                                </Link>
                            ))}
                        </div>
						<br />
						<br />
                        <div className="view-all-link">
                            <Link to="/services" className="btn-primary" style={{color: "#0a1523", textDecoration: "none"}}>
                                View All Services &rarr;
                            </Link>
                        </div>
                    </div>
                </section>
                <Pricing />
                {/* <Testimonials /> */}
                <TrustedBy />
                
            </main>
            {/* <Footer /> */}
        </div>
    );
};

export default Home;